
import * as React from 'react';
import { switchLayout } from '../../../operations/switchLayout';
import { layoutTypeFacet, availableLayoutsFacet, defaultLayoutFacet } from '../../../facets/ScopeFacets';
import { IItemCacheDispatch } from '../../../store/actions/ItemCacheActions';
import { connectToItemCache } from '../../decorators/connectToItemCache';
import { IItemCache } from '../../../models/IItemCacheObserver';
import { IActionProps, Action } from '../../action/Action';
import { connectToItemsScope } from '../../decorators/connectToItemsScope';
import { withCurrentItem } from '../../decorators/selectors';
import { getItemActionEngagement } from '../../../models/telemetry/getItemEngagement';
import { LayoutTypeFacet } from '../../../models/layouts/LayoutTypeFacet';
import { pack } from '../../../models/Facet';

/**
 * @public
 */
export interface ISwitchLayoutActionProps {
  itemKey: string;
  itemsScopeItemKey: string;
  layoutType: LayoutTypeFacet;
}

/**
 * @public
 */
export const SwitchLayoutAction: React.ComponentType<Pick<ISwitchLayoutActionProps, 'layoutType'>> =
  withCurrentItem()(connectToItemsScope()(connectToItemCache((
    itemCache: IItemCache,
    props: ISwitchLayoutActionProps
  ): IActionProps => {
    const {
      itemKey,
      layoutType,
      itemsScopeItemKey
    } = props;

    const availableLayouts = itemCache.demandItemFacet(availableLayoutsFacet, itemsScopeItemKey) || pack({}, {});

    const preferredLayoutType = itemCache.demandItemFacet(layoutTypeFacet, itemsScopeItemKey);
    const preferredLayout = preferredLayoutType && availableLayouts[preferredLayoutType.id] && preferredLayoutType || undefined;

    const defaultLayoutType = itemCache.demandItemFacet(defaultLayoutFacet, itemsScopeItemKey);
    const defaultLayout = defaultLayoutType && availableLayouts[defaultLayoutType.id] && defaultLayoutType || undefined;

    const isLayoutCurrent = (preferredLayout || defaultLayout) === layoutType;

    return {
      isAvailable: !!itemKey && !isLayoutCurrent && !!availableLayouts && !!availableLayouts[layoutType.id],
      isToggled: isLayoutCurrent,
      ...getItemActionEngagement(itemCache, {
        itemKey,
        engagement: {
          name: 'SwitchLayout',
          isIntentional: true,
          extraData: {
            layoutType: layoutType.name
          }
        }
      })
    };
  }, (
    dispatch: IItemCacheDispatch,
    props: ISwitchLayoutActionProps
  ): IActionProps => {
      const {
        layoutType,
        itemsScopeItemKey
      } = props;

      const onExecute = async () => {
        dispatch(switchLayout({
          itemsScopeItemKey: itemsScopeItemKey,
          layoutType: layoutType
        }));
      };

      return {
        onExecute
      };
    })(Action)
  ));
